import { useEffect } from 'react'

const TestError = () => {
  useEffect(() => {
    const causeError = () => {
      throw new Error('Test error for Sentry sourcemap verification')
    }

    setTimeout(() => {
      causeError()
    }, 500)
  }, [])

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">
          Sentry Test Page
        </h1>
        <p className="text-gray-600 mb-4">
          This page will throw an error in 500ms to test Sentry sourcemap
          integration.
        </p>
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
          <p className="text-sm text-yellow-700">
            Check your Sentry dashboard to see if the error is captured with
            proper source mapping!
          </p>
        </div>
      </div>
    </div>
  )
}

export default TestError
